import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HiringManagerStatusComponent } from './components/hiring-manager-status/hiring-manager-status.component';

const components = [
  HiringManagerStatusComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule
  ],
  exports: components
})
export class HiringManagerModule { }
